import React from "react";

import clsx from "clsx";

import ImgBgDecoration from "@assets/images/header-homepage-2025-bg-decoration.png";
import { HeaderHomepage2025 } from "@app/api/modules/header-homepage/header-homepage-2025.module";
import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { ClickableComponent } from "@app/core/clickable";
import { Usps2025 } from "@app/components/usps-2025/usps-2025";
import { CtaLinkBlock } from "@app/components/cta-link-block/cta-link-block";
import { DEFAULT_MERCHANT_MAX, MerchantSlider } from "@app/components/merchant-slider/merchant-slider";
import { useAppSelector } from "@app/redux/store";

import { HomepageBanners } from "./components/homepage-banners";
import styles from "./header-homepage-2025.module.scss";

export interface IHomePageHeader2025Props {
  module: HeaderHomepage2025;
}

const HeaderHomepage2025Module = ({ module }: IHomePageHeader2025Props) => {
  const { title, subtitle, cta, usps, buttons, banners, merchantSlider } = module;
  const [titleOne, titleTwo] = getHeaderTitle(title);

  const { merchants } = useAppSelector(state => state.merchantOverview);

  return (
    <div className={styles.root}>
      <div className={styles.bg}>
        <img className={styles.bgDecoration} src={ImgBgDecoration} />
        <div className={clsx("uk-container", styles.container)}>
          <div className={styles.wrapper}>
            <div className={styles.content}>
              {title && (
                <h1>
                  <span>{titleOne}</span>
                  <span>{titleTwo}</span>
                </h1>
              )}
              {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
              {cta?.url && (
                <ClickableComponent
                  className={styles.ctaButton}
                  variant="primary-2025-brand-big"
                  iconStyle="filled"
                  title={cta.title}
                  iconRight={IcnChevronRight}
                  href={cta.url}
                />
              )}
              {(usps || []).length > 0 && (
                <div className={styles.usps}>
                  <Usps2025 usps={usps?.map(u => u.title).filter(Boolean)} />
                </div>
              )}
            </div>
            {banners.length > 0 && (
              <div className={styles.rennabWrapper}>
                <HomepageBanners banners={banners} />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="uk-container">
        <div className={styles.bottomWrapper}>
          {buttons && buttons.length > 0 && (
            <div className={styles.ctaLinkBlocks}>
              {buttons.map((button, index) => (
                <CtaLinkBlock
                  key={index}
                  title={button.title}
                  subtitle={button.subtitle}
                  url={button.link?.url}
                  target={button.link?.target}
                  count={button.count}
                />
              ))}
            </div>
          )}
          {merchantSlider?.showSlider && merchants.length > 0 && (
            <MerchantSlider
              merchants={merchants.slice(0, DEFAULT_MERCHANT_MAX)}
              title={merchantSlider.showTitle ? merchantSlider.title : undefined}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export { HeaderHomepage2025Module };

const getHeaderTitle = (title?: string): string[] => (title || "")?.split("<br>");
